const blockProducts = () => {
    document.addEventListener("DOMContentLoaded", () => {
        const blocks = document.querySelectorAll(".block-products__section");
        if (!blocks.length) return;

        blocks.forEach((block) => {
            const btns = [...block.querySelectorAll(".block-products__label__btn")];
            const galleries = [...block.querySelectorAll(".block-products__gallery__list")];
            if (!btns.length || !galleries.length) return;

            const TOTAL = btns.length;
            const STEP = 120;
            let current = btns.findIndex(b => b.classList.contains("active")) || 0;
            let labelAccum = 0;

            const labelCol = block.querySelector(".block-products__label__list");

            // ── Inizializza tutti gli Swiper subito, una volta sola ──
            galleries.forEach((g) => {
                new Swiper(g.querySelector('.swiper'), {
                    slidesPerView: "auto",
                    spaceBetween: 20,
                    pagination: {
                        el: g.querySelector('.swiper-pagination'),
                        clickable: true,
                        dynamicBullets: true,
                    },
                });
            });

            function activate(index) {
                if (index < 0 || index >= TOTAL) return;
                btns.forEach((b, i) => b.classList.toggle("active", i === index));
                galleries.forEach((g, i) => {
                    g.classList.toggle("active", i === index);
                    if (i === index) g.scrollTop = 0;
                });
                current = index;
            }

            btns.forEach((btn) => {
                btn.addEventListener("click", (e) => {
                    e.preventDefault();
                    activate(btns.indexOf(btn));
                    const y = block.getBoundingClientRect().top + window.pageYOffset - 110;
                    window.scrollTo({ top: y, behavior: "smooth" });
                });
            });

            labelCol.addEventListener("mouseenter", () => { labelAccum = 0; });
            labelCol.addEventListener("mouseleave", () => { labelAccum = 0; });

            labelCol.addEventListener("wheel", (e) => {
                if ((e.deltaY > 0 && current >= TOTAL - 1) ||
                    (e.deltaY < 0 && current <= 0)) return;
                e.preventDefault();
                e.stopPropagation();
                labelAccum += e.deltaY;
                if (labelAccum > STEP) { activate(current + 1); labelAccum = 0; }
                else if (labelAccum < -STEP) { activate(current - 1); labelAccum = 0; }
            }, { passive: false });
        });
    });
};

export default blockProducts;